export default "__VITE_ASSET__CXroQ1hM__"